import { alpha, SxProps, Theme } from '@mui/material';

/**
 * Returns sx for the activity filter toggle with a light tinted background when selected.
 */
export function getTintedSelectedToggleSx(selectedColor: string): SxProps<Theme> {
  return {
    '&.Mui-selected': {
      backgroundColor: alpha(selectedColor, 0.12),
      color: 'inherit',
      '&:hover': {
        backgroundColor: alpha(selectedColor, 0.18),
      },
      '& .MuiSvgIcon-root': {
        color: selectedColor,
      },
    },
  };
}
